function error(field, formik) {
  return formik.touched[field] && formik.errors[field] && (
    <span className="text-danger">{formik.errors[field]}</span>
  );
}

export default error;
